import { Rating } from "primereact/rating";
import React, { useEffect, useState } from "react";
// import { IconContext } from "react-icons";
// import {
//   BsFillHeartFill as Heart,
//   BsFillShareFill as ShareButton,
// } from "react-icons/bs";
import "../../index.css";
import {
  // createSearchParams,
  Link,
  useLocation,
  useNavigate,
  // useNavigate,
} from "react-router-dom";
import MainButton from "../../components/common/MainButton/MainButton";
// import ProgressBar from "../../components/common/ProgressBar/ProgressBar";
// import RatingStars from "../../components/common/RatingStars/RatingStars";
// import useAuth from "../../Hooks/useAuth";
// import { useServiceReviews } from "../../Hooks/useServices";
import Login from "../Login/Login";
import { SignUp } from "../SignUp/SignUp";
import useClickOutside from "../../Hooks/useClickOutside";
import { useRef } from "react";
import PortfolioBanner from "../Portfolio/PortfolioBanner";
import PosterRanking from "../PosterProfile/PosterRanking";
import PosterReviews from "../PosterProfile/PosterReviews";
import Popup from "../../components/popup/Popup";
import SecondaryHeading from "../../components/common/Typography/SecondaryHeading";
import Paragraph from "../../components/common/Typography/Paragraph";
import Heading from "../../components/common/Typography/Heading";
import ReviewSubmissionForm from "../../components/common/ReviewForm/ReviewSubmissionForm";
import Title from "../../components/common/Title/Title";
import ProfileComponent from "../../components/common/Profile/ProfileComponent";
import ButtonText from "../../components/common/Typography/ButtonText";
import SpecialText from "../../components/common/Typography/SpecialText";
import Popups from "../../components/popup/Popups";
import QoutingForms from "./QouteForms/QoutingForms";
import useAuth from "../../Hooks/useAuth";
import PostReport from "../../components/common/ReportForm/PostReport";
import AdsCard from "../../components/common/AdsCard/AdsCard";
import { GetPostsByUserIdAndStatus, GetPostsByCategory } from "../../services/PostService";
import { useGraphQL } from "../../context/GraphQLProvider";
import Spinner from "../../components/common/Spinner";
import AuxiliaryText from "../../components/common/Typography/AuxiliaryText";
import Pro from "../../components/common/Tags/Pro";
import ProfileSpecialtyChips from "../../components/common/Profile/ProfileSpecialtyChips";
import { useDispatch } from 'react-redux';
import { setRedirectPath } from '../../Redux/Slice/authRedirectSlice';
import InquiryForm from '../../components/InquiryForm';
import SharePopup from '../../components/common/SharePopup/SharePopup';
import PostReportForm from '../../components/common/PostReportForm/PostReportForm';
import { useLoginActionService, LOGIN_SCENARIOS } from '../../services/LoginActionService';
import {
  publicMainHeaderOffsetClass,
  PUBLIC_HEADING_TO_CONTENT_CLASS,
  PUBLIC_HEADING_TO_CONTENT_COMPACT_CLASS,
  PUBLIC_CONTENT_TO_CTA_CLASS,
  PUBLIC_DIVIDER_VERTICAL_GAP_CLASS,
  PUBLIC_CARD_GRID_GAP_CLASS,
  PUBLIC_POST_DETAIL_PROFILE_AVATAR_CLASS,
  PUBLIC_POST_DETAIL_PROFILE_AVATAR_WRAPPER_CLASS,
  PUBLIC_POST_DETAIL_PROFILE_PRO_BADGE_CLASS,
  PUBLIC_POST_DETAIL_PROFILE_NOTCH_CLASS,
} from '../Public/shared/publicLayoutSpec';
const ServiceDetailsContainer = ({ data }) => {
  const [report, setReport] = useState(false);
  const [profileReport, setProfileReport] = useState(false);
  const [qouting, setQouting] = useState(false);
  const [ShowCrossButton, setShowCrossButton] = useState(true);
  const [isReadMore, setIsReadMore] = useState(true);
  const [dotMenuOpen, setDotMenuOpen] = useState(false);
  // const getReactionInfo = AuthnicateData?.data?.$values.find(
  //   (e) => e.id?.toString() === ListingId.toString()
  // );
  const listingInfo = data;
  const navigate = useNavigate();
  // const [heartClick, setheartClick] = useState(getReactionInfo?.listReaction);
  const { auth } = useAuth();
  const [SignUpState, setSignUpState] = React.useState(false);
  const [SignIn, setSignIn] = React.useState(false);
  // const ListImage = JSON?.parse(listingInfo.pictures);
  const location = useLocation();
  const graphqlService = useGraphQL();
  const [userPosts, setUserPosts] = useState([]);
  const [userPostsLoading, setUserPostsLoading] = useState(false);
  const [categoryPosts, setCategoryPosts] = useState([]);
  const [categoryPostsLoading, setCategoryPostsLoading] = useState(false);
  const [inquiryOpen, setInquiryOpen] = useState(false);
  const [inquiryAction, setInquiryAction] = useState('post');
  const [inquiryData, setInquiryData] = useState(null);
  const [isSaved, setIsSaved] = useState(false);
  const loginActionService = useLoginActionService();
  const [saveCount, setSaveCount] = useState(listingInfo?.likes || 0);
  const [sharePopupOpen, setSharePopupOpen] = useState(false);
  const [profileSharePopupOpen, setProfileSharePopupOpen] = useState(false);
  const dispatch = useDispatch();

  // Function to open inquiry form with specific action and data
  const openInquiryForm = (action, data) => {
    setInquiryAction(action);
    setInquiryData(data);
    setInquiryOpen(true);
  };

  // Function to open post report form
  const openPostReportForm = () => {
    setReport(true);
  };

  // Function to open profile report form
  const openProfileReportForm = () => {
    setProfileReport(true);
  };

  // Handle save/heart button click
  const handleSaveClick = () => {
    if (!auth?.user) {
      dispatch(setRedirectPath(location.pathname + location.search));
      setSignIn(true);
      return;
    }
    
    if (isSaved) {
      setIsSaved(false);
      setSaveCount(prev => prev - 1);
    } else {
      setIsSaved(true);
      setSaveCount(prev => prev + 1);
    }
  };

  // Handle share button click
  const handleShareClick = () => {
    setSharePopupOpen(true);
  };

  // Handle profile share button click
  const handleProfileShareClick = () => {
    setProfileSharePopupOpen(true);
    setDotMenuOpen(false); // Close dot menu when share popup opens
  };

  // Parse content data to get images
  const parsedImages = React.useMemo(() => {
    try {
      if (listingInfo?.content) {
        const contentArray = JSON.parse(listingInfo.content);
        return contentArray.map(image => ({
          original: image.url,
          thumbnail: image.url
        }));
      }
      return [];
    } catch (error) {
      console.error("Error parsing content:", error);
      return [];
    }
  }, [listingInfo?.content]);

  // const { data: reviewsData, status } = useServiceReviews(ListingId);
  // const [ReviewsList, setReviewsList] = useState();
  // useEffect(() => {
  //   const sortOrderByDescbyRating = (List) => {
  //     let sortedDsc = List?.sort((a, b) => {
  //       return parseInt(b.starRating) - parseInt(a.starRating);
  //     });
  //     return sortedDsc;
  //   };
  //   setReviewsList(sortOrderByDescbyRating(reviewsData?.data?.key?.$values));
  // }, [ListingId, reviewsData]);

  // const ReviewHandler = () => {
  //   if (!auth?.user) {
  //     setSignIn(true);
  //   } else {
  //     navigate({
  //       pathname: "/WriteReview/",
  //       search: `?${createSearchParams({
  //         id: ListingId,
  //       })}`,
  //     });
  //   }
  // };

  const ReadMore = ({ children }) => {
    const text = children;

    const toggleReadMore = () => {
      setIsReadMore(!isReadMore);
    };
    return (
      <>
        <div className="text-inline w-full">
          {isReadMore ? text.split(/\s+/).slice(0, 30).join(" ") : text}
          <p className="group relative border-b-2 border-lightgray w-[77px] lg:w-[78px] cursor-pointer pb-1 mt-4">
            <span
              onClick={toggleReadMore}
              className="cursor-pointer"
            >
              {isReadMore ? (
                <ButtonText variant={"SecondaryText"}>Read more</ButtonText>
              ) : (
                <ButtonText variant={"SecondaryText"}>Read less</ButtonText>
              )}
            </span>
            <span class="absolute -bottom-[2px] left-0 w-0 border-b-2 border-primaryblue transition-all duration-100 group-hover:w-[68px] lg:group-hover:w-[70px] xl:group-hover:w-[74px]" />
          </p>
        </div>
      </>
    );
  };
  useEffect(() => {
    if (report || profileReport || qouting || inquiryOpen || sharePopupOpen || profileSharePopupOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "visible";
      document.body.style.width = `auto`;
    }
  }, [report, profileReport, qouting, inquiryOpen, sharePopupOpen, profileSharePopupOpen]);

  const ref = useRef(null);
  useClickOutside(ref, () => {
    setIsReadMore(true);
  });
  
  const dotMenuRef = useRef(null);
  useClickOutside(dotMenuRef, () => {
    setDotMenuOpen(false);
  });
  //  const interfaceIcons = [
  //   icon:
  //  ]

  useEffect(() => {
    const fetchUserPosts = async () => {
      if (!listingInfo?.user?.id) return;
      setUserPostsLoading(true);
      try {
        const response = await GetPostsByUserIdAndStatus(graphqlService, {
          userId: listingInfo.user.id,
          status: "published"
        });
        setUserPosts(response?.getPostsByStatus	 || []);
      } catch (err) {
        setUserPosts([]);
      } finally {
        setUserPostsLoading(false);
      }
    };
    fetchUserPosts();
  }, [listingInfo?.user?.id, graphqlService]);

  useEffect(() => {
    const fetchCategoryPosts = async () => {
      if (!listingInfo?.mainCategory) return;
      setCategoryPostsLoading(true);
      try {
        const response = await GetPostsByCategory(graphqlService, {
          filters: { mainCategory: listingInfo.mainCategory }
        });
        setCategoryPosts(response?.getPostsByCategory?.posts || []);
      } catch (err) {
        setCategoryPosts([]);
      } finally {
        setCategoryPostsLoading(false);
      }
    };
    fetchCategoryPosts();
  }, [listingInfo?.mainCategory, graphqlService]);

  return (
    <>
      {SignIn && (
        <Login
          location={location.pathname + location.search}
          SignIn={SignIn}
          setSignIn={setSignIn}
          SignUpState={SignUpState}
          setSignUpState={setSignUpState}
          onLoginSuccess={() => {
            console.log('onLoginSuccess called in ServiceDetailsContainer component');
            
            // Create a function that can handle different popup types based on the scenario
            const handlePopupOpen = (popupType, data) => {
              console.log('handlePopupOpen called with:', { popupType, data });
              switch (popupType) {
                case 'inquiry_form':
                  // Handle inquiry_form by determining the correct action from data
                  if (data && data.action) {
                    // If action is specified in data, use it
                    const inquiryData = data.action === 'post' ? data.postData : data.profileData;
                    openInquiryForm(data.action, inquiryData);
                  } else if (data && data.postData) {
                    // If postData is present, treat as post inquiry
                    openInquiryForm('post', data.postData);
                  } else if (data && data.profileData) {
                    // If profileData is present, treat as profile inquiry
                    openInquiryForm('profile', data.profileData);
                  } else {
                    // Default fallback to post inquiry with current listing
                    openInquiryForm('post', listingInfo);
                  }
                  break;
                case 'post':
                  // Direct post inquiry
                  openInquiryForm('post', data?.postData || listingInfo);
                  break;
                case 'profile':
                  // Direct profile inquiry
                  openInquiryForm('profile', data?.profileData || listingInfo?.user);
                  break;
                case 'quote_request_form':
                  // This would be handled by Header component
                  break;
                case 'post_report_form':
                  openPostReportForm();
                  break;
                case 'profile_report_form':
                  openProfileReportForm();
                  break;
                default:
                  console.log('Unknown popup type:', popupType);
              }
            };

            // Check for pending scenarios after login
            const hasPendingScenario = loginActionService.checkAndHandlePendingScenario(handlePopupOpen);

            // Close login modal after handling pending scenario to prevent blink
            if (hasPendingScenario) {
              // If there's a pending scenario, close login modal after opening the popup
              setTimeout(() => {
                setSignIn(false);
              }, 150); // Delay to ensure popup opens first, then login modal closes
            } else {
              // If no pending scenario, close login modal immediately
              setSignIn(false);
            }
          }}
        />
      )}
      {SignUpState && (
        <SignUp
          location={location.pathname + location.search}
          SignUpState={SignUpState}
          setSignUpState={setSignUpState}
          SignIn={SignIn}
          setSignIn={setSignIn}
        />
      )}
      {qouting && (
        <Popup
          setTrigger={setQouting}
          ShowCrossButton={ShowCrossButton}
          onClose={() => setQouting(false)}
        >
          <QoutingForms closePopup={() => setQouting(false)} />
        </Popup>
      )}
      
      {/* Inquiry Form Popup */}
      <InquiryForm
        isOpen={inquiryOpen}
        onClose={() => setInquiryOpen(false)}
        action={inquiryAction}
        postData={inquiryAction === 'post' ? inquiryData : null}
        profileData={inquiryAction === 'profile' ? inquiryData : null}
      />
      
      {/* Share Popup - service card (same as category page) + share actions */}
      <SharePopup
        isOpen={sharePopupOpen}
        onClose={() => setSharePopupOpen(false)}
        postTitle={listingInfo?.postTitle}
        currentUrl={window.location.href}
        variant="project"
        projectTitle={listingInfo?.postTitle}
        businessName={listingInfo?.user?.businessName}
        previewCompanyLogo={listingInfo?.user?.profilePicture}
        listingData={listingInfo}
      />
      
      {/* Profile Share Popup */}
      <SharePopup
        isOpen={profileSharePopupOpen}
        onClose={() => setProfileSharePopupOpen(false)}
        postTitle={listingInfo?.user?.businessName || listingInfo?.user?.firstName + " " + listingInfo?.user?.lastName || "Profile"}
        currentUrl={`${window.location.origin}/poster-profile/?id=${listingInfo?.user?.id}`}
        shareType="profile"
      />
      
      {/* Post Report Form */}
      <PostReportForm
        isOpen={report}
        onClose={() => setReport(false)}
        postData={listingInfo}
      />
      
      {/* Profile Report Form */}
      <PostReportForm
        isOpen={profileReport}
        onClose={() => setProfileReport(false)}
        postData={listingInfo?.user}
        reportType="profile"
      />
      <div className="relative w-full px-5">
        <div className={`tp-container-small mx-auto ${publicMainHeaderOffsetClass()}`}>
          {/* Post title row */}
          <div className="w-full mb-8">
            <h1 className="widget-title text-offblack">{listingInfo?.postTitle}</h1>
          </div>
          {/* Profile and button row */}
          <div className="flex items-center justify-between mb-8">
            <div className="flex items-center gap-2">
              <div className="relative">
                <Link to={`/poster-profile/?id=${listingInfo?.user?.id}`}>
                  <img
                    src={listingInfo?.user?.profilePicture || require('../../assets/img/default-image.jpg')}
                    alt={listingInfo?.user?.businessName}
                    className="avatar-small object-cover"
                  />
                </Link>
                {listingInfo?.user?.userPlan?.plan?.name?.toLowerCase() === 'pro' && (
                  <div className="absolute -bottom-1 left-1/2 -translate-x-1/2">
                    <Pro className="bg-primaryblue text-white" />
                  </div>
                )}
              </div>
              <SpecialText variant="ProfileName">
                {listingInfo?.user?.businessName}
              </SpecialText>
            </div>
            <MainButton
              variant="small"
              onClick={() => {
                loginActionService.handleLoginTrigger(LOGIN_SCENARIOS.SERVICE_DETAILS_POST_INQUIRY.id, {
                  setSignIn,
                  currentPath: location.pathname + location.search,
                  auth,
                  setPopupOpen: (popupType, data) => {
                    // For post inquiry, always use 'post' action
                    openInquiryForm('post', listingInfo);
                  },
                  popupData: { action: 'post', postData: listingInfo }
                });
              }}
            >
              Get in touch
            </MainButton>
          </div>
          {/* Main image/gallery */}
          <div className="relative flex justify-center items-start">
            <PortfolioBanner images={parsedImages} />
            {/* Icon bar positioned inside the container */}
            <div className="hidden md:flex flex-col gap-2 z-20 absolute -right-20 top-10">
              <Title text="Views" width="60" className="!ml-2 md:!ml-[50px]">
                <button type="button" className="icon-circle bg-transparent border border-mediumgray mb-2 relative transition-all duration-200">
                  <i className="fi fi-rs-eye text-offblack" />
                  <span className="counter-number absolute -top-[6px] left-[69%] bg-primaryblue text-white rounded-full min-w-5 h-5 px-1 flex items-center justify-center">{listingInfo?.views || 0}</span>
                </button>
              </Title>
              <Title text="Save this post" width="100" className="!ml-2 md:!ml-[50px]">
                <button 
                  onClick={handleSaveClick}
                  type="button"
                  className="icon-circle bg-transparent border border-mediumgray mb-2 relative transition-all duration-200"
                >
                  <i className={`fi fi-rs-heart transition-colors duration-200 ${isSaved ? 'text-alertred' : 'text-offblack'}`} />
                  <span className="counter-number absolute -top-[6px] left-[69%] bg-primaryblue text-white rounded-full min-w-5 h-5 px-1 flex items-center justify-center">{saveCount}</span>
                </button>
              </Title>
              <Title text="Share this post" width="109" className="!ml-2 md:!ml-[50px]">
                <button 
                  onClick={handleShareClick}
                  type="button"
                  className="icon-circle bg-transparent border border-mediumgray mb-2 relative transition-all duration-200"
                >
                  <i className="fi fi-rs-share text-offblack" />
                  <span className="counter-number absolute -top-[6px] left-[69%] bg-primaryblue text-white rounded-full min-w-5 h-5 px-1 flex items-center justify-center">12</span>
                </button>
              </Title>
              {/* Only show report button if user is not the post owner */}
              {auth?.user?.id !== listingInfo?.user?.id && (
                <Title text="Flag this post" width="109" className="!ml-2 md:!ml-[50px]">
                  <button 
                    onClick={() => {
                      loginActionService.handleLoginTrigger(LOGIN_SCENARIOS.SERVICE_DETAILS_POST_REPORT.id, {
                        setSignIn,
                        currentPath: location.pathname + location.search,
                        auth,
                        setPopupOpen: openPostReportForm,
                        popupData: { postData: listingInfo }
                      });
                    }}
                    type="button"
                    className="icon-circle bg-transparent border border-mediumgray relative transition-all duration-200"
                  >
                    <i className="fi fi-rs-flag-alt text-offblack" />
                  </button>
                </Title>
              )}
            </div>
          </div>
          {/* Description */}
          <div className={`flex flex-col items-center ${PUBLIC_HEADING_TO_CONTENT_CLASS}`}>
            <Paragraph variant="MainParagraph" className="text-offblack max-w-3xl text-left">
              {listingInfo?.postDescription}
            </Paragraph>
          </div>

          </div>
          <div className="tp-container-small mx-auto max-w-[1172px]">
          {/* Profile below post text — avatar-standard tier from Platform Icon, Avatar and Label System */}
          <div className="mt-28 mb-10 w-full">
            <div className="grid w-full grid-cols-[1fr_auto_1fr] items-center">
              <div className="min-w-0 border-t border-mediumgray" />
              <div className={PUBLIC_POST_DETAIL_PROFILE_NOTCH_CLASS}>
                <Link
                  to={`/poster-profile/?id=${listingInfo?.user?.id}`}
                  className="inline-flex"
                >
                  <div className={PUBLIC_POST_DETAIL_PROFILE_AVATAR_WRAPPER_CLASS}>
                    <img
                      src={listingInfo?.user?.profilePicture || require('../../assets/img/default-image.jpg')}
                      alt={listingInfo?.user?.businessName}
                      className={PUBLIC_POST_DETAIL_PROFILE_AVATAR_CLASS}
                    />
                    {listingInfo?.user?.userPlan?.plan?.name?.toLowerCase() === 'pro' && (
                      <span className={PUBLIC_POST_DETAIL_PROFILE_PRO_BADGE_CLASS}>
                        <Pro className="bg-primaryblue text-white" />
                      </span>
                    )}
                  </div>
                </Link>
              </div>
              <div className="min-w-0 border-t border-mediumgray" />
            </div>
            <div className="mt-2 flex flex-col items-center gap-2">
            <SpecialText variant="ProfileName">
              {listingInfo?.user?.businessName}
            </SpecialText>
            <SpecialText variant="ProfileMeta">
              {listingInfo?.user?.serviceCategory?.name || 'Category'}
            </SpecialText>
            <ProfileSpecialtyChips />
            <SpecialText variant="ProfileMicro">
              {listingInfo?.user?.location || ''}
            </SpecialText>
            <SpecialText variant="Date">
              Member since {listingInfo?.user?.startDate ? new Date(listingInfo.user.startDate).getFullYear() : 'N/A'}
            </SpecialText>
            {/* Profile average rating: same as reviews (filled star + Counter text) */}
            <div className="flex items-center justify-center">
              <div className="flex items-center">
                <Rating
                  value={4.3}
                  stars={1}
                  style={{ gap: 5 }}
                  cancel={false}
                  readOnly
                />
                <SpecialText variant="Counter" className="ml-1 text-offblack">
                  4.3
                </SpecialText>
              </div>
            </div>
            {/* <div className="flex items-center gap-3 mt-2">
              <MainButton
                variant="small"
                className=""
                onClick={() => {
                  loginActionService.handleLoginTrigger(LOGIN_SCENARIOS.SERVICE_DETAILS_PROFILE_INQUIRY.id, {
                    setSignIn,
                    currentPath: location.pathname + location.search,
                    auth,
                    setPopupOpen: (popupType, data) => {
                      // For profile inquiry, always use 'profile' action
                      openInquiryForm('profile', listingInfo?.user);
                    },
                    popupData: { action: 'profile', profileData: listingInfo?.user }
                  });
                }}
              >
                Get in Touch
              </MainButton>
              <div className="relative">
                <MainButton
                  variant="outlinesmall"
                  className="!w-auto aspect-square"
                  onClick={() => setDotMenuOpen(!dotMenuOpen)}
                >
                  <i className="fi fi-bs-menu-dots text-base flex items-center justify-center"></i>
                </MainButton>
                {dotMenuOpen && (
                  <div 
                    ref={dotMenuRef}
                    className="flex flex-col rounded-xl w-48 py-3 absolute z-30 bg-white text-offblack mt-2 left-1/2 transform -translate-x-1/2 shadow-lg border border-gray-200"
                  >
                    <button className="block px-4 py-2 hover:text-primaryblue w-full text-center">
                      <AuxiliaryText variant={"MenuDropdown"}>
                        Follow
                      </AuxiliaryText>
                    </button>
                    <button className="block px-4 py-2 hover:text-primaryblue w-full text-center">
                      <AuxiliaryText variant={"MenuDropdown"}>
                        Call
                      </AuxiliaryText>
                    </button>
                    <button 
                      onClick={handleProfileShareClick}
                      className="block px-4 py-2 hover:text-primaryblue w-full text-center"
                    >
                      <AuxiliaryText variant={"MenuDropdown"}>
                        Share
                      </AuxiliaryText>
                    </button>
                    <button 
                      onClick={() => {
                        loginActionService.handleLoginTrigger(LOGIN_SCENARIOS.SERVICE_DETAILS_PROFILE_REPORT.id, {
                          setSignIn,
                          currentPath: location.pathname + location.search,
                          auth,
                          setPopupOpen: openProfileReportForm,
                          popupData: { profileData: listingInfo?.user }
                        });
                      }}
                      className="block px-4 py-2 hover:text-primaryblue w-full text-center"
                    >
                      <AuxiliaryText variant={"MenuDropdown"}>
                        Report
                      </AuxiliaryText>
                    </button>
                    <button className="block px-4 py-2 hover:text-primaryblue w-full text-center">
                      <AuxiliaryText variant={"MenuDropdown"}>
                        Block
                      </AuxiliaryText>
                    </button>
                  </div>
                )}
              </div>
            </div> */}
            </div>
          </div>
        </div>
      </div>
      {/* More by Provider Section */}
      <div className="px-5">
        <div
          className={`tp-container-small max-w-[1172px] mx-auto ${PUBLIC_CONTENT_TO_CTA_CLASS}`}
        >
          <div className="flex justify-between items-center">
            <h2 className="text-lg font-semibold">More by {listingInfo?.user?.businessName || 'Provider'}</h2>
            <button
              type="button"
              className="bg-transparent border-none p-0 m-0 align-baseline cursor-pointer"
              onClick={() => navigate(`/poster-profile/?id=${listingInfo?.user?.id}`)}
            >
              <div className="group relative cursor-pointer w-[85px]">
                <ButtonText variant="SecondaryText" className="group-hover:text-primaryblue">
                  Visit Profile
                </ButtonText>
                {/* <span className="absolute -bottom-[2px] left-0 w-0 border-b-2 border-primaryblue transition-all duration-100 group-hover:w-[85px] lg:group-hover:w-[85px] xl:group-hover:w-[85px] 2xl:group-hover:w-[85px]" /> */}
              </div>
            </button>
          </div>
          {userPostsLoading ? (
            <></>
          ) : (
            <div
              className={`grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 ${PUBLIC_CARD_GRID_GAP_CLASS} ${PUBLIC_HEADING_TO_CONTENT_COMPACT_CLASS}`}
            >
              {userPosts
                .filter(post => post.id !== listingInfo?.id)
                .slice(0, 4)
                .map((post, idx) => {
                  let images = [];
                  try {
                    if (post.content) {
                      const contentArray = JSON.parse(post.content);
                      images = contentArray.map(img => ({ url: img.url }));
                    }
                  } catch (e) {
                    images = [];
                  }
                  if (!images.length) images = [{ url: 'https://via.placeholder.com/300x200' }];
                  return (
                    <AdsCard
                      key={post.id}
                      serviceId={post.id}
                      serviceName={post.postTitle}
                      serviceDescription={post.postDescription}
                      Images={images}
                      companyName={listingInfo?.user?.businessName || 'Provider'}
                      companyLogo={listingInfo?.user?.profilePicture}
                      category={listingInfo?.user?.serviceCategory}
                      likes={post.likes || 0}
                      views={post.views || 0}
                      reaction={false}
                      companyId={listingInfo?.user?.id}
                      userPlan={listingInfo?.user?.userPlan?.plan?.name?.toLowerCase()}
                      hideUserInfo={true}
                      hideShare={true}
                      hideHeart={true}
                      hideLikes={true}
                      hideViews={true}
                    />
                  );
                })}
            </div>
          )}
        </div>
      </div>
      <div className={PUBLIC_DIVIDER_VERTICAL_GAP_CLASS}>
        <div className="w-full border-t border-mediumgray" />
      </div>
      {/* End More by Provider Section */}
      {/* You might also like Section */}
      <div className="px-5">
        <div
          className={`tp-container-small max-w-[1172px] mx-auto ${PUBLIC_DIVIDER_VERTICAL_GAP_CLASS}`}
        >
          <div className="flex justify-between items-center">
            <h2 className="text-lg font-semibold">You might also like</h2>
          </div>
          {categoryPostsLoading ? (
            <></>
          ) : (
            <div
              className={`grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 ${PUBLIC_CARD_GRID_GAP_CLASS} ${PUBLIC_HEADING_TO_CONTENT_COMPACT_CLASS}`}
            >
              {categoryPosts
                .filter(post => post.id !== listingInfo?.id)
                .slice(0, 6)
                .map((post, idx) => {
                  let images = [];
                  if (post.postImages && post.postImages.length > 0) {
                    images = post.postImages.map(img => ({ url: img.imageUrl }));
                  } else if (post.content) {
                    try {
                      const contentArray = JSON.parse(post.content);
                      images = contentArray.map(img => ({ url: img.url }));
                    } catch (e) {
                      images = [];
                    }
                  }
                  if (!images.length) images = [{ url: 'https://via.placeholder.com/300x200' }];
                  return (
                    <AdsCard
                      key={post.id}
                      serviceId={post.id}
                      serviceName={post.postTitle}
                      serviceDescription={post.postDescription}
                      Images={images}
                      companyName={post.user?.businessName || 'Provider'}
                      companyLogo={post.user?.profilePicture}
                      category={post.user?.serviceCategory}
                      likes={post.likes || 0}
                      views={post.views || 0}
                      reaction={false}
                      companyId={post.user?.id}
                      userPlan={post.user?.userPlan?.plan?.name?.toLowerCase()}
                    />
                  );
                })}
            </div>
          )}
        </div>
      </div>
      {/* End You might also like Section */}
      {/* Footer is assumed to be already implemented elsewhere */}
    </>
  );
};

export default ServiceDetailsContainer;
